import React, { createContext, useState, useContext } from "react";

const PreloaderContext = createContext();

export const usePreloader = () => {
  return useContext(PreloaderContext);
};

export const PreloaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <PreloaderContext.Provider value={{ loading, setLoading }}>
      {children}
    </PreloaderContext.Provider>
  );
};
